define('model/ClientModel',['require','lib/model/BaseModel','underscore','lib/validator/ValidatorEmail','lib/validator/ValidatorPhone','lib/validator/ValidatorIntlPhone','lib/validator/ValidatorNotEmpty','Config'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
    var ValidatorEmail = require('lib/validator/ValidatorEmail');
    var ValidatorPhone = require('lib/validator/ValidatorPhone');
    var ValidatorIntlPhone = require('lib/validator/ValidatorIntlPhone');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
    var Config = require('Config');

    /**
     * Client info model
     *
     * @class ClientModel
     */
    return BaseModel.extend({

        url: '/ext/client/',

        defaults: {
            id: null,
            is_logged_in: false,
            name: '',
            email: '',
            country_id: null,
            state_id: null,
            address1: '',
            address2: '',
            zip: '',
            city: '',
            phone: '',
            password: '',
            user_id: null
        },

        initialize: function () {
            this.listenTo(this, 'sync', this.onChange);
            this.listenTo(this, 'change', this.onChange);

            var config = Config.getInstance();

            this.validators = {
                'name': [new ValidatorNotEmpty()],
                'email': [new ValidatorNotEmpty(), new ValidatorEmail()],
                'phone': [new ValidatorIntlPhone({
                    allowedPrefix: config.getOption('country_prefix_is_changeable')?null:config.getOption('country_prefix'),
                    checkPhoneRequired : true,
                })]
            };
            if (config.getPluginStatus('client_login')) {
                this.validators.password = [new ValidatorNotEmpty()];
            }
            if (config.getPluginStatus('client_login') && config.getBooleanOption('client_login_require_address')) {
                _.extend(this.validators, {
                    'country_id': [new ValidatorNotEmpty()],
                    'address1': [new ValidatorNotEmpty()],
                    'city': [new ValidatorNotEmpty()],
                    'zip': [new ValidatorNotEmpty()]
                });
            }
            if (config.getPluginStatus('client_login')) {
                var phoneRequire = config.getBooleanOption('client_login_require_phone');
                if (phoneRequire) {
                    this.validators.phone.push(new ValidatorNotEmpty());
                }
            }

            BaseModel.prototype.initialize.call(this);
        },

        save: function () {
            var config = Config.getInstance();
            if (this.get('with_address') === false && config.getBooleanOption('client_login_require_address') === false) {
                var addressFields = ['address1', 'address2', 'city', 'zip', 'state_id'];
                _.each(addressFields, function (field) {
                    this.set(field, null, {silent: true});
                }, this);
            }

            BaseModel.prototype.save.apply(this, arguments);
        },

        authByCode: function(code, handler) {
            if (!code) {
                handler();
                return;
            }
            var _this = this;

            var options = {
                parse: false,
                attrs: {
                    code: code
                },
                url: '/v2/client/auth-by-code'
            };

            this.syncWithPromise('create', options).then(_.bind(function (data) {
                console.log(2);
                handler();
            }), _.bind(function (data) {
                handler();
            }, this));
        },

        loginByLineIdToken: function (attrs, handler, errorHandler){
            var _this = this;

            var options = {
                parse: true,
                attrs: attrs,
                url: this.url
            };

            this.syncWithPromise('create', options).then(_.bind(function (data) {
                _this.fetch({reset:true});
                if(handler){
                    handler();
                }
            }), _.bind(function (data) {
                if(errorHandler){
                    errorHandler(data);
                }
            }, this));
        },

        onChange: function () {
            var config = Config.getInstance();
            if (!config.getPluginStatus('client_login')) {
                return;
            }
            this._setValidatePassword((this.get('is_logged_in') == false && this.get('user_id') == null));
        },

        _setValidatePassword: function (flag) {
            this.validators.password = [];
            if (flag) {
                this.validators.password = [new ValidatorNotEmpty()];
            }
        },

        navigateToSignIn: function () {
            Backbone.history.navigate('client/sign-in', {
                trigger: true
            });
        },

        saveClientTerms: function(acceptedTerms){
            // this.set('terms', acceptedTerms, {silent: true});
            // BaseModel.prototype.save.apply(this, arguments);
            //
            var _this = this;
            return new Promise(function(resolve, reject) {
                Backbone.sync('update', _this, {
                    'method': 'POST',
                    'url': _this.url + 'terms/terms',
                    'success': resolve,
                    'attrs': {
                        id: _this.get('id'),
                        terms: acceptedTerms
                    },
                    'error': function(xhr) {
                        var res = xhr.responseJSON;
                        if(res && res.errors) {
                            reject(res.errors);
                        }else {
                            reject([]);
                        }
                    },
                });
            });
        }

    });

});
